import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { Checkbox } from 'shared/ui/Checkbox/Checkbox'
import styles from './styles.module.scss'

type IScopeBlockProps = {
  scopes: string[]
  selectedScopes: string[]
  toggleScope: (scope: string) => void
  disabled?: boolean
}

export const ScopeBlock = observer(
  ({ scopes, selectedScopes, toggleScope, disabled }: IScopeBlockProps) => {
    return (
      <div className={styles.scopesSection}>
        <Typography variant='body-md-semibold' ariaLabel='ScopesSectionLabel'>
          Scope
        </Typography>
        <div>
          {[...scopes]
            .sort((a, b) => a.localeCompare(b))
            .map((scope) => (
              <label key={scope} className={styles.scopeItem}>
                <Checkbox
                  size={16}
                  checked={selectedScopes.includes(scope)}
                  onChange={() => toggleScope(scope)}
                  ariaLabel={scope}
                  disabled={disabled}
                />
                <Typography
                  variant='body-md-regular'
                  ariaLabel={scope}
                  className={styles.scopeLabel}
                  color='var(--gray-80)'
                >
                  {scope}
                </Typography>
              </label>
            ))}
        </div>
      </div>
    )
  }
)
